import httpClient from '@/api/http-client'

const urlPrefix = '/bpm/v1/kanban/favorites'

export default {

  /**
   * Получение списка избранных досок.
   *
   * @returns {*}
   */
  favorites() {

    return httpClient.http
      .get( `${urlPrefix}/` )
      .then( response => {
        return response.data
      })
  },

  /**
   * Добавление доски в избранное.
   *
   * @param {String} boardId
   * @returns {*}
   */
  addFavorite( boardId ) {

    return httpClient.http
      .put( `${urlPrefix}/${boardId}` )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Удаление доски из избранного.
   *
   * @param {String} boardId
   * @returns {*}
   */
  deleteFavorite( boardId ) {

    return httpClient.http
      .delete( `${urlPrefix}/${boardId}` )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Получение списка публикаций для выбранной доски.
   *
   * @param {String} boardId
   * @returns {*}
   */
  publications( boardId ) {

    return httpClient.http
      .get( `/bpm/v1/kanban/boards/${boardId}/publications` )
      .then( response => {
        return response.data.publications
      })
  },
}



// WEBPACK FOOTER //
// ./src/apps/bpm/kanban/api/favorite/api.js